import { render, staticRenderFns } from "./href.vue?vue&type=template&id=b4e3cec6&"
import script from "./href.vue?vue&type=script&lang=js&"
export * from "./href.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports